import { useEffect, useRef } from "react";
import appHistory from "../../../app/appHistory";
import { locationSlice } from "../locationReducer";
import { useDispatch } from "react-redux";

function useLocationListenPrevLocation() {
    const dispatch = useDispatch();
    const currentLocation = useRef(appHistory.location);

    useEffect(() => {
        appHistory.listen((location) => {
            dispatch(locationSlice.actions.setPrevLocationAction(currentLocation.current));
            currentLocation.current = location;
        });
    }, [dispatch]);
}

export default useLocationListenPrevLocation;
